import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useEffect, useState } from 'react';
import { apiB2B, apiB2C, apiBase } from '../api/axios-client';
import { ERR_REDIRECT } from '../constants/response-error-messages';
import { getWindow } from '../utils/general';
import { redirectToSignIn } from '../utils/http-helper';
export var useInterceptors = function () {
    var _a = useState(null), redirectError = _a[0], setRedirectError = _a[1];
    var isLoggedIn = useThdCustomer().isLoggedIn;
    useEffect(function () {
        var _a, _b, _c;
        if (((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) === '/myaccount/guest-order-tracking') {
            return;
        }
        var location = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.location;
        if (!location)
            return;
        var fullPath = location.pathname + location.search;
        if (fullPath === '/myaccount/cancel-items?guestAccess=true') {
            return;
        }
        if (!isLoggedIn) {
            redirectToSignIn();
            setRedirectError(ERR_REDIRECT);
        }
    }, []);
    var logonMiddleware = function (error) {
        var _a;
        var response = error.response;
        var flagExceptions = ![
            'buyitagain',
            'orderdetails',
            'guest-order-tracking',
        ].includes((_a = response === null || response === void 0 ? void 0 : response.request) === null || _a === void 0 ? void 0 : _a.responseURL.split('/').at(-1));
        if (response &&
            flagExceptions &&
            (response.status === 401 || response.status === 431)) {
            redirectToSignIn();
            setRedirectError(ERR_REDIRECT);
        }
        return Promise.reject(error);
    };
    apiB2B.interceptors.response.use(undefined, logonMiddleware);
    apiB2C.interceptors.response.use(undefined, logonMiddleware);
    apiBase.interceptors.response.use(undefined, logonMiddleware);
    return {
        redirectError: redirectError,
    };
};
